import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ChangeDetectorRef,
  QueryList,
  ViewChildren,
  OnDestroy
} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ReportsService} from "../reports.service";
import {CurrentRouteService} from "../../currentRoute.service";
import {AccountIdService, AgencyIdService} from "../../account.service";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ThemePalette} from '@angular/material/core';
import {environment} from '../../../environments/environment';
import * as _moment from 'moment';
import * as _ from "lodash";
import {MatTableDataSource} from "@angular/material/table";
import {AdgroupIdInterfaceData, CampaignIdInterfaceData} from "../../shared/models/adwords.model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatAccordion} from "@angular/material/expansion";

import { Observable, interval, pipe } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';

export interface AttributionInterfaceData {
  network: string,
  cost: number,
  revenue: string
}

export interface  AttributionSalesInterfaceData {
  amount: number,
  description: string,
  service: string,
  first_action_id: string,
  last_action_id: string,
  first_provider: string,
  last_provider: string
  //conversions?: number,
}

export interface  FirstClickSalesInterfaceData {
  campaign_name: string,
  adgroup_name: string,
  impressions: number,
  clicks: number,
  amount: number,
  count: number
  cps: number
}


export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
}

const moment = _moment;

@Component({
  selector: 'app-report-attribution',
  templateUrl: './report-attribution.component.html',
  styleUrls: ['./report-attribution.component.css']
})
export class ReportAttributionComponent implements OnInit, OnDestroy {

  /*
  Notes: The name of radoo buttons and checkboxes for google is google but the back end expects googleads
  THe ui is the first line of defence for ensuring the correct data is sent to the backend for google
  Later backend development will provide a second line of defence bit now now.  Postman api calls for testing will
  require googlads to be used

  For future refact we should create a lookup object given the name of the contraol to send the correct value to the backend
  For the interim we rely on converting to lower case and testing ikf Google and if so then we send googleads
   */

  helps = [];
  first_click_data = [];

  agency_id: string;
  account_id: string;
  start_date: any;
  end_date: any;
  myForm: UntypedFormGroup;
  is_loading = false;
  is_data = false;
  is_data_loaded = false;
  is_journey_data_loaded = false;
  is_table_column_hidden: boolean = false;
  is_running = false;

  report_type_list = [{name: "First Click", id: 'attribution_first_click'},
                      {name: "First Click - Sales", id: 'attribution_first_click_ad_spend'},
                      {name: "Last Click - Sales", id: 'attribution_last_click_ad_spend'},
                      {name: "Attribution - Sales", id: 'attribution_sales'},
                      {name: "Attribution - Calls", id: 'attribution_calls'}
                      ]

  displayedColumns: string[] = ['purchase_dt','service','amount', 'description', 'fullName','emailAddress','phoneNumberStandard', 'first_event_dt','first_action_id', 'first_provider', 'first_adgroup','star'];
  dataSource: MatTableDataSource<CampaignIdInterfaceData>;
  // @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  // @ViewChild(MatSort, {static: true}) sort: MatSort;

  displayedColumnsAttributionSales: string[] = ['purchase_dt','service','amount', 'description','fullName','emailAddress','phoneNumberStandard','first_event_dt','first_action_id','first_provider','first_adgroup','last_event_dt','last_action_id','last_provider','last_adgroup','star'];
  dataSourceAttributionSales: MatTableDataSource<AttributionSalesInterfaceData>;
  // @ViewChild(MatPaginator, {static: true}) paginatorAttributionSales: MatPaginator;
  // @ViewChild(MatSort, {static: true}) sortAttributionSales: MatSort;

  displayedColumnsFirstClickSales: string[] = ['campaign_name','adgroup_name','impressions', 'clicks','spend','amount','count','cps','star'];
  dataSourceFirstClickSales: MatTableDataSource<FirstClickSalesInterfaceData>;

  //https://stackoverflow.com/questions/50428605/multiple-material-pagination-in-one-component-doesnt-work-in-angular
  //NOTE: THE QUERY FILTER ... ALL TABLES USED this.sort.toArray()[0] SINCE HIDDEN I GUESS
  // FILTER, SORT, PAGINATION WORKS
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();



  constructor(
    private cdr: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private reportService: ReportsService,
    private currentrouteService: CurrentRouteService,
    private agencyidService: AgencyIdService,
    private accountidService: AccountIdService,) {}

  option_list = [];

  ngOnInit(): void {

    // https://stackoverflow.com/questions/53733807/disabling-console-log-in-production
    // if (environment["environment"] === "production") {
    //   console.log = function() {}
    // }

    this.myForm = this.fb.group({
      start_date: [, Validators.required],
      end_date: [, Validators.required],
    })//end myForm

    this.route.params.subscribe(parms => {
      this.account_id = parms['account_id']
      //this.loadData(this.account_id)
      console.log('report campaign performance', this.account_id)
    });

    let query_parms = this.route.snapshot.queryParamMap;

    //this.pollUntillCompleted('111')
  } //end ngOnInit

  ngOnDestroy(): void {
    this.stopRunning()
  }

  stopRunning(){

    if (this.polling_subscription){
      this.polling_subscription.unsubscribe()
    }

    if (this.getPollEndpointService){
      this.getPollEndpointService.unsubscribe()
    }

    if (this.getFirstLastClickSalesService){
      this.getFirstLastClickSalesService.unsubscribe()
    }

    if (this.getFirstClickAttributionService){
      this.getFirstClickAttributionService.unsubscribe()
    }

    if (this.getSalesCallsAttributionService){
      this.getSalesCallsAttributionService.unsubscribe()
    }

    this.is_loading = false;
    this.is_running = false;

  }


  adspendRadioNetworkValue: string = "Facebook";
  seasons: string[] = ['Facebook', 'Google'];
  season:string;

  /****************************/
  /* CHECK BOX LOGIC          */
  /****************************/
  task: Task = {
    name: 'Sources',
    completed: false,
    color: 'primary',
    subtasks: [
      {name: 'Organic', completed: false, color: "primary"},
      {name: 'Facebook', completed: false, color: "primary"},
      {name: 'Google', completed: false, color: "primary"},
    ],
  };

  allComplete: boolean = false;

  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach(t => (t.completed = completed));
  }
  /****************************/


  getPollEndpointService: any;
  getPollEndpoint(report_id){

    this.is_loading = true;

    let endpoint = `reports?rt=poller&report_id=${report_id}`;
    this.getPollEndpointService = this.reportService.get(endpoint).subscribe(x => {


      let poll_status = x['body']['status']
      console.log('STATUS!!!!!!!!!!!!',poll_status)
      if (poll_status != 'pending'){
        console.log(x['body'])
        this.polling_subscription.unsubscribe();

        this.is_data_loaded = false;
        if (_.isEmpty(x['body'])) {
          this.is_data = true;
          this.is_loading = false;
          this.is_running = false;
        } else {
          let keys = Object.keys(x['body'])
          for (var _i = 0; _i < keys.length; _i++) {
            console.log(x['body'][_i])
            this.report_list.push(x['body'][_i])
          } //end loop

          if (this.report_type=='attribution_first_click_ad_spend' || this.report_type=='attribution_last_click_ad_spend') {
            this.displayedColumnsFirstClickSales = ['campaign_name', 'adgroup_name', 'impressions', 'clicks', 'spend', 'amount', 'count', 'cps', 'star'];
            this.dataSourceFirstClickSales = new MatTableDataSource(this.report_list);
            this.cdr.detectChanges();
            this.dataSourceFirstClickSales.paginator = this.paginator.toArray()[0];
            this.dataSourceFirstClickSales.sort = this.sort.toArray()[0];
            this.is_data_loaded = true;
            this.is_loading = false;
          } //end attribution_first_click_ad_spend || attribution_last_click_ad_spend

          if (this.report_type=='attribution_first_click'){
            this.dataSource = new MatTableDataSource(this.report_list);
            this.cdr.detectChanges();
            // this.dataSource.paginator = this.paginator;
            // this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator.toArray()[0];
            this.dataSource.sort = this.sort.toArray()[0];
          }

          if (this.report_type=='attribution_sales'){
            this.displayedColumnsAttributionSales = ['purchase_dt','service','amount', 'description','fullName','emailAddress','phoneNumberStandard','first_event_dt','first_action_id','first_provider','first_adgroup','last_event_dt','last_action_id','last_provider','last_adgroup','star'];

            this.dataSourceAttributionSales = new MatTableDataSource(this.report_list);
            this.cdr.detectChanges();
            // this.dataSourceAttributionSales.paginator = this.paginatorAttributionSales;
            // this.dataSourceAttributionSales.sort = this.sortAttributionSales;
            this.dataSourceAttributionSales.paginator = this.paginator.toArray()[0];
            this.dataSourceAttributionSales.sort = this.sort.toArray()[0];
          }
          if (this.report_type=='attribution_calls'){
            this.displayedColumnsAttributionSales = ['purchase_dt','service','fullName','emailAddress','phoneNumberStandard','first_event_dt','first_action_id','first_provider','first_adgroup','last_event_dt','last_action_id','last_provider','last_adgroup','star'];

            this.dataSourceAttributionSales = new MatTableDataSource(this.report_list);
            this.cdr.detectChanges();
            // this.dataSourceAttributionSales.paginator = this.paginatorAttributionSales;
            // this.dataSourceAttributionSales.sort = this.sortAttributionSales;
            this.dataSourceAttributionSales.paginator = this.paginator.toArray()[0];
            this.dataSourceAttributionSales.sort = this.sort.toArray()[0];
          }

          this.is_data_loaded = true;
          this.is_loading = false;
          this.is_running = false;
        } //end isEmpty
      } //end if !pending

    }, error => {
      this.is_loading = false;
      this.is_data = true;
      this.is_running = false;
      this.polling_subscription.unsubscribe();
      }
    )


  } // end getPollEndpoint(report_id)

  polling_subscription: any;
  pollUntillCompleted(report_id) {
    this.polling_subscription = interval(5000).subscribe(x => {
      console.log('pollUntillCompleted', x)
      this.getPollEndpoint(report_id)
    })
  } //pollUntillCompleted(report_id)

  getFirstLastClickSalesService: any;
  getFirstLastClickSales(start, end) {

    // CALLED FROM SUBMIT

    this.is_loading = true;
    this.report_list = [];
    let rt = ''
    let tracker_provider_filter = '';
    tracker_provider_filter = this.adspendRadioNetworkValue.toLowerCase( );
    if (tracker_provider_filter=="google"){
      tracker_provider_filter = "googleads"
    }
    console.log('tracker_provider_filter:',tracker_provider_filter)
    let endpoint = `reports?rt=${this.report_type}&account_id=${this.account_id}&start_date=${start}&end_date=${end}&report_type=${rt}&tracker_provider_filter=${tracker_provider_filter}&worker=true`;
    console.log(endpoint)
    this.getFirstLastClickSalesService = this.reportService.get(endpoint).subscribe(x => {
      console.log('getPollEndpoing!!!!!!!!!!!!!!!!!!!!!!!', x['body']['status'])
      let report_id = x['body']['report_id']
      this.pollUntillCompleted(report_id)
    })
  } //getLastClickSales(start, end)

  getFirstClickAttributionService: any;
  getFirstClickAttribution(start, end) {

    // CALLED FROM SUBMIT
    this.is_loading = true;
    this.report_list = [];
    let rt = ''
    let tracker_provider_filter = '';
    for (var _i = 0; _i < this.task.subtasks.length; _i++) {
      console.log(this.task.subtasks[_i])
      if (this.task.subtasks[_i]['completed']==true){
        //tracker_provider_filter.push(this.task.subtasks[_i]['name'].toLowerCase())
        let tracker_name = this.task.subtasks[_i]['name'].toLowerCase()
        if (tracker_name=='google'){
          tracker_name = 'googleads'
        }
        //tracker_provider_filter = tracker_provider_filter  + this.task.subtasks[_i]['name'].toLowerCase() + ','
        tracker_provider_filter = tracker_provider_filter  + tracker_name  + ','
      }
    }
    tracker_provider_filter = tracker_provider_filter.slice(0, -1)
    console.log('tracker_provider_filter:',tracker_provider_filter)


    let endpoint = `reports?rt=${this.report_type}&account_id=${this.account_id}&start_date=${start}&end_date=${end}&report_type=${rt}&tracker_provider_filter=${tracker_provider_filter}&worker=true&ignore_solo_events=true`;
    console.log(endpoint)
    this.getFirstClickAttributionService = this.reportService.get(endpoint).subscribe(x => {
      console.log('getPollEndpoing!!!!!!!!!!!!!!!!!!!!!!!', x['body']['status'])
      let report_id = x['body']['report_id']
      this.pollUntillCompleted(report_id)
    })
  } //getLastClickSales(start, end)

  getSalesCallsAttributionService: any;
  getSalesCallsAttribution(start, end) {

    // CALLED FROM SUBMIT
    this.is_loading = true;
    this.report_list = [];
    let rt = ''
    if (this.report_type=='attribution_sales'){
      rt = 'sales'
    }
    if (this.report_type=='attribution_calls'){
      rt = 'calls'
    }


    let tracker_provider_filter = '';
    console.log('tracker_provider_filter:',tracker_provider_filter)

    let endpoint = `reports?rt=${this.report_type}&account_id=${this.account_id}&start_date=${start}&end_date=${end}&report_type=${rt}&tracker_provider_filter=${tracker_provider_filter}&worker=true`;
    console.log(endpoint)
    this.getSalesCallsAttributionService = this.reportService.get(endpoint).subscribe(x => {
      console.log('getPollEndpoing!!!!!!!!!!!!!!!!!!!!!!!', x['body']['status'])
      let report_id = x['body']['report_id']
      this.pollUntillCompleted(report_id)
    })


  }





  report_list = []
  loadData(start, end) {
    this.report_list = [];
    this.is_loading = true;
    let endpoint = '';

    let rt = ''
    if (this.report_type=='attribution_sales'){
      rt = 'sales'
    }
    if (this.report_type=='attribution_calls'){
      rt = 'calls'
    }


    let tracker_provider_filter = '';
    for (var _i = 0; _i < this.task.subtasks.length; _i++) {
      console.log(this.task.subtasks[_i])
      if (this.task.subtasks[_i]['completed']==true){
        //tracker_provider_filter.push(this.task.subtasks[_i]['name'].toLowerCase())
        let tracker_name = this.task.subtasks[_i]['name'].toLowerCase()
        if (tracker_name=='google'){
          tracker_name = 'googleads'
        }
        //tracker_provider_filter = tracker_provider_filter  + this.task.subtasks[_i]['name'].toLowerCase() + ','
        tracker_provider_filter = tracker_provider_filter  + tracker_name  + ','
      }
    }
    tracker_provider_filter = tracker_provider_filter.slice(0, -1)

    if (this.report_type=="attribution_first_click_ad_spend" || this.report_type=="attribution_last_click_ad_spend"){
      tracker_provider_filter = this.adspendRadioNetworkValue.toLowerCase( );
      if (tracker_provider_filter=="google"){
        tracker_provider_filter = "googleads"
      }
    }

    endpoint = `reports?rt=${this.report_type}&account_id=${this.account_id}&start_date=${start}&end_date=${end}&report_type=${rt}&tracker_provider_filter=${tracker_provider_filter}&ignore_solo_events=true`;
    this.is_data = false;
    console.log(endpoint)
    let fu = this.reportService.get(endpoint).subscribe(x => {

      console.log(x)
      this.is_data_loaded = false;
      if (_.isEmpty(x['body'])) {
        this.is_data = true;
        this.is_loading = false;
        this.is_running = false;
      } else {
        let keys = Object.keys(x['body'])
        for (var _i = 0; _i < keys.length; _i++) {
          console.log(x['body'][_i])
          this.report_list.push(x['body'][_i])
        } //end loop

        if (this.report_type=='attribution_first_click'){
          this.dataSource = new MatTableDataSource(this.report_list);
          this.cdr.detectChanges();
          // this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort.toArray()[0];
          this.first_click_data = this.report_list;
        }

        if (this.report_type=='attribution_first_click_ad_spend' || this.report_type=='attribution_last_click_ad_spend'){
          this.displayedColumnsFirstClickSales = ['campaign_name','adgroup_name','impressions', 'clicks','spend','amount','count','cps','star'];
          this.dataSourceFirstClickSales = new MatTableDataSource(this.report_list);
          this.cdr.detectChanges();
          this.dataSourceFirstClickSales.paginator = this.paginator.toArray()[0];
          this.dataSourceFirstClickSales.sort = this.sort.toArray()[0];
        }

        if (this.report_type=='attribution_sales'){
          this.displayedColumnsAttributionSales = ['purchase_dt','service','amount', 'description','fullName','emailAddress','phoneNumberStandard','first_event_dt','first_action_id','first_provider','first_adgroup','last_event_dt','last_action_id','last_provider','last_adgroup','star'];

          this.dataSourceAttributionSales = new MatTableDataSource(this.report_list);
          this.cdr.detectChanges();
          // this.dataSourceAttributionSales.paginator = this.paginatorAttributionSales;
          // this.dataSourceAttributionSales.sort = this.sortAttributionSales;
          this.dataSourceAttributionSales.paginator = this.paginator.toArray()[0];
          this.dataSourceAttributionSales.sort = this.sort.toArray()[0];
        }
        if (this.report_type=='attribution_calls'){
          this.displayedColumnsAttributionSales = ['purchase_dt','service','fullName','emailAddress','phoneNumberStandard','first_event_dt','first_action_id','first_provider','first_adgroup','last_event_dt','last_action_id','last_provider','last_adgroup','star'];

          this.dataSourceAttributionSales = new MatTableDataSource(this.report_list);
          this.cdr.detectChanges();
          // this.dataSourceAttributionSales.paginator = this.paginatorAttributionSales;
          // this.dataSourceAttributionSales.sort = this.sortAttributionSales;
          this.dataSourceAttributionSales.paginator = this.paginator.toArray()[0];
          this.dataSourceAttributionSales.sort = this.sort.toArray()[0];
        }

        this.is_data_loaded = true;
        this.is_loading = false;
        this.is_running = false;

      }


    }, error => {
      console.log('ERROR@@@@@@@@@@@@@@@@@@@@ ',error)
      this.is_loading = false;
      this.is_data = true;
      this.is_running = false;
    }); //end apiService

  } //end loadData

  addDateEvent(type, event) {
    console.log(type, event.value)
    this.is_data = false;

  } //end addDateEvent

  report_type: string;
  selectEventReport(event){
    this.report_list = [];
    this.report_type = event.value;
    this.is_loading = false;

    if (event.value=='attribution_sales'){
      // This is useful to see if the first event is the same as the last event.
      // If the first and last event are the same, then the sale was likely a direct sale.
      // If the first and last event are different, then the sale was likely an indirect sale.",
      this.helps = [
        "Attribution Sales Report",
        "This report will show the first and last event for each sale.",
        "All events even prior to the selected date range are included in this report.",
      ]
    } else {
      this.helps = []
    }

    // //reset all
    // this.is_data = false;
    // this.campaign_name_list = [];
    // this.adgroup_name_list = [];
    // this.hc_timeseries_list = [];
    // this.timeseries_list = [];
    // this.adgroup_table_list = [];

  }

  getTableRecord(row) {
  } // end getTableRecord( )

  applyFilterMulti(event: Event, dataSource: any) {
    //applyFilter($event, table.dataSource)
    //https://stackoverflow.com/questions/62540355/how-to-add-multiple-tables-each-having-filter-sort-pagination-in-angular-mater
    //USE THE ABOVE TO CREATE A SINGLE FILTER PER DATASORUCE
    const filterValue = (event.target as HTMLInputElement).value;
    dataSource.filter = filterValue.trim().toLowerCase();
    if (dataSource.paginator) {
      dataSource.paginator.firstPage();
    }
  }

  applyFilterAttributionSales(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceAttributionSales.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceAttributionSales.paginator) {
      this.dataSourceAttributionSales.paginator.firstPage();
    }
  } // applyFilter

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } // applyFilter


  onSubmit() {

    this.is_data = false;
    this.is_running = true;
    this.first_click_data = [];

    /*
    On local we call loadData becuase it was tge first
    methond that calls the enpoing directrly withouut polling.
    We do not do polling on local only on remote.  Local has no liminations
    when it comes to timeouts.

    TODO: Refactoir the polling methods to be a single method that can be called
    for local and remote tp avoid having to maintain two methods.  Kill loadData.
     */

    let start_date = this.myForm.value['start_date']
    start_date = moment(start_date);
    start_date = start_date.format('YYYY-MM-DD');

    let end_date = this.myForm.value['end_date']
    end_date = moment(end_date);
    end_date = end_date.format('YYYY-MM-DD');

    this.start_date = start_date;
    this.end_date = end_date;

    if (environment['environment']=='local'){
      this.loadData(start_date, end_date);
    } else {
      if (this.report_type=="attribution_first_click_ad_spend" || this.report_type=='attribution_last_click_ad_spend'){
        this.getFirstLastClickSales(start_date, end_date)
      } else if (this.report_type=='attribution_first_click'){
        this.getFirstClickAttribution(start_date, end_date)
      } else if (this.report_type=="attribution_sales" || this.report_type=='attribution_calls') {
        this.getSalesCallsAttribution(start_date, end_date)
      }

    }








  } //end onSubmit

} //end component
